export default __webpack_public_path__ + "static/media/collective.ee6651c5.svg";